import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createWithout, getOrdersCode } from 'services/ordersService';
import { criteriaRules } from 'utils/constants';
import upload from '../../../assets/uploadIcon.png';
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection';
import { TextArea } from 'components/atoms/TextArea/TextArea';
import AppButton from 'components/atoms/AppButton/AppButton';
import Message, { MessageProps } from 'components/atoms/Message/Message';
import InputFileUpload from 'components/atoms/InputFileUpload/InputFileUpload';
import { AppTable } from '../../molecules/AppTable/AppTable';
import CardResumeMessage from 'components/atoms/CardResumeMessage/CardResumeMessage';
import { Order } from 'interfaces/order';
import { useOperationModes } from 'core/hooks/useOperationModes';
import { OperationMode } from 'core/domain/operationMode';

// 26 chutes disponibles por defecto para órdenes sin plantilla


const INITIAL_STATE = {
    file: null,
    template_id: 0,
    description: '',
}
const breadcrumbNavigate = [
    {
        label: 'Ordenes',
        path: '/ordenes',
    },
    {
        label: 'Cargar orden',
        path: '/orders/create/no-template',
    },
]
export const CreateOrdersNoCriteria = () => {
    const navigate = useNavigate()
    const [code, setCode] = useState<null | string>(null)
    const [data, setData] = useState<Order>(INITIAL_STATE)
    const [message, setMessage] = useState<MessageProps>({
        message: '',
        type: 'default',
    })
    const [sortConfig, setSortConfig] = useState<{
        column: string
        direction: 'asc' | 'desc'
    } | null>(null)

    // Modo de operación
    const { operationModes, isSorterMode, isClassificationMode, findById } = useOperationModes()
    const [selectedOperationMode, setSelectedOperationMode] = useState<OperationMode | null>(null)



    const handleOperationModeChange = (code: string, id: number) => {
        const mode = findById(id)
        setSelectedOperationMode(mode)
        setData(INITIAL_STATE)
        
    }
    const handleSortColumn = (order: 'asc' | 'desc', columnTitle: string) => {
        setSortConfig({
            column: columnTitle,
            direction: order,
        })
    }

    const sendData = async () => {
        try {
            if (!data.file) {
                setMessage({
                    message: 'Por favor selecciona un archivo',
                    type: 'error',
                })
                setTimeout(() => {
                    setMessage({ message: '', type: 'default' })
                }, 5000)
                return
            }
            
            if (!selectedOperationMode) {
                setMessage({
                    message: 'Por favor selecciona un modo de operación',
                    type: 'error',
                })
                setTimeout(() => {
                    setMessage({ message: '', type: 'default' })
                }, 5000)
                return
            }
            
            const formData = new FormData()
            formData.append('file', data.file)
            formData.append('description', data.description)
            formData.append('classification_type_id', String(selectedOperationMode.id))
            await createWithout(formData)
            setData(INITIAL_STATE)
            setMessage({
                message: 'Orden creada exitosamente',
                type: 'success',
            })
            setTimeout(() => {
                setMessage({ message: '', type: 'default' })
                navigate('/orders')
            }, 5000)
        } catch (error) {
            setData(INITIAL_STATE)
            setMessage({
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                message: (error as any).message || 'Error al crear la orden',
                type: 'error',
            })
            setTimeout(() => {
                setMessage({ message: '', type: 'default' })
            }, 5000)
        }
    }

    useEffect(() => {
        const fetchPackages = async () => {
            const { data } = await getOrdersCode()
            setCode(data.code)
        }
        fetchPackages()
    }, [])

    // Seleccionar Sorting por defecto cuando se carguen los modos de operación
    useEffect(() => {
        if (operationModes.length > 0 && !selectedOperationMode) {
            const sorterMode = operationModes.find((mode) => mode.code === 'sorter')
            if (sorterMode) {
                setSelectedOperationMode(sorterMode)
            }
        }
    }, [operationModes, selectedOperationMode])

    return (
        <>
            <HeaderPageSection
                title="Cargar orden sin criterios"
                showGoBack={false}
                breadcrumbItems={breadcrumbNavigate}
            />
            {message.type !== 'default' && (
                <Message message={message.message} type={message.type} />
            )}
            <div className="bg-white rounded-lg">
                <div className="flex flex-wrap p-[32px] gap-4 ">
                    <div className="flex-1">
                        <h2 className="text-[20px] font-semibold mb-[32px]">
                            Orden #{code}
                        </h2>

                        {/* Modo de Operación — obligatorio */}
                        <div className="mb-[32px]">
                            <p className="text-sm text-[#3E5060] mb-3 font-semibold">Modo de operación*</p>
                            <div className="flex items-center gap-6">
                                {operationModes.map((mode) => {
                                    const isChecked = selectedOperationMode?.code === mode.code
                                    return (
                                        <label
                                            key={mode.id}
                                            className="flex items-center gap-2 cursor-pointer"
                                            onClick={() => handleOperationModeChange(mode.code, mode.id)}
                                        >
                                            {/* Radio custom */}
                                            <div
                                                className="w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0"
                                                style={{
                                                    borderColor: isChecked ? '#568C13' : '#CBD5E1',
                                                    backgroundColor: isChecked ? '#568C13' : 'white',
                                                }}
                                            >
                                                {isChecked && (
                                                    <div className="w-[6px] h-[6px] rounded-full bg-white" />
                                                )}
                                            </div>
                                            <span className="text-sm text-[#070A13]">
                                                {mode.name}
                                            </span>
                                        </label>
                                    )
                                })}
                            </div>
                        </div>

                        <div className="mb-[32px]">
                            {data.file?.name ? (
                                <CardResumeMessage
                                    title={
                                        data.file?.name !== undefined
                                            ? data.file?.name
                                            : 'test'
                                    }
                                    onClose={() => {
                                        setData({ ...data, file: null })
                                        setMessage({
                                            message: '',
                                            type: 'default',
                                        })
                                    }}
                                    icon={upload}
                                />
                            ) : (
                                <InputFileUpload
                                    accept=".xlsx"
                                    onSubmit={(file) =>
                                        setData({
                                            ...data,
                                            file: file as File,
                                        })
                                    }
                                    label="Carga el archivo de importaciones"
                                    children={
                                        <a
                                            className="text-[14px] text-[#475569]"
                                            href={isClassificationMode(selectedOperationMode) ? require('../../../assets/order_without_template.xlsx') : require('../../../assets/order_without_template_chute.xlsx')}
                                            download={
                                                isClassificationMode(selectedOperationMode) ? 'order_without_template.xlsx' : 'order_without_template_chute.xlsx'
                                            }
                                        >
                                            Haga clic{' '}
                                            <span className="text-[#76BD1D]">
                                                aquí
                                            </span>{' '}
                                            para descargar un archivo de
                                            plantilla.
                                        </a>
                                    }
                                />
                            )}
                        </div>
                        <div>
                            <p>Descripción (opcional)</p>
                            <TextArea
                                value={data.description}
                                placeholder="Escribe algunas líneas para describir a la orden"
                                onChange={(value: string) =>
                                    setData({ ...data, description: value })
                                }
                            />
                        </div>
                    </div>
                    <div className="border"></div>
                    <div className="flex-1">
                        <h2 className="text-[16px] font-semibold mb-4">
                            Estructura de archivos
                        </h2>
                        <AppTable
                            dataHead={
                                isSorterMode(selectedOperationMode)
                                    ? [
                                          {
                                              title: 'Nombre de archivo',
                                              id: 'title',
                                              state:
                                                  sortConfig?.column === 'Nombre de archivo'
                                                      ? sortConfig.direction
                                                      : 'asc',
                                          },
                                          {
                                              title: 'Regla de validación',
                                              id: 'rules',
                                              state:
                                                  sortConfig?.column === 'Regla de validación'
                                                      ? sortConfig.direction
                                                      : 'asc',
                                          },
                                      ]
                                    : [
                                          {
                                              title: 'Nombre de archivo',
                                              id: 'title',
                                              state:
                                                  sortConfig?.column === 'Nombre de archivo'
                                                      ? sortConfig.direction
                                                      : 'asc',
                                          },
                                          {
                                              title: 'Regla de validación',
                                              id: 'rules',
                                              state:
                                                  sortConfig?.column === 'Regla de validación'
                                                      ? sortConfig.direction
                                                      : 'asc',
                                          },
                                      ]
                            }
                            onSortColumn={handleSortColumn}
                        >
                            <tbody>
                                {isSorterMode(selectedOperationMode) ? (
                                    // Modo Sorter: muestra Tracking y Chutes
                                    <>
                                        <tr className="border-b hover:bg-gray-50">
                                            <td className="text-center text-sm py-3">Tracking</td>
                                            <td className="text-center text-sm py-3">
                                                Requerido | Texto | Max: 255
                                            </td>
                                        </tr>
                                        <tr className="border-b hover:bg-gray-50 last:border-0">
                                            <td className="text-center text-sm py-3">Chute</td>
                                            <td className="text-center text-sm py-3">
                                                Requerido | Integer | "1 - 42"
                                            </td>
                                        </tr>
                                        <tr className="border-b hover:bg-gray-50 last:border-0">
                                            <td className="text-center text-sm py-3">Provider Service</td>
                                            <td className="text-center text-sm py-3">
                                                Opcional | Texto | Max:255
                                            </td>
                                        </tr>
                                    </>
                                ) : isClassificationMode(selectedOperationMode) ? (
                                    // Modo Classification: muestra Tracking y Regla
                                    <>
                                        <tr className="border-b hover:bg-gray-50">
                                            <td className="text-center text-sm py-3">Tracking</td>
                                            <td className="text-center text-sm py-3">
                                                Requerido | Texto | Max: 255
                                            </td>
                                        </tr>
                                        <tr className="border-b hover:bg-gray-50 last:border-0">
                                            <td className="text-center text-sm py-3">Regla</td>
                                            <td className="text-center text-sm py-3">
                                                Requerido | Texto | Max: 255
                                            </td>
                                        </tr>
                                        <tr className="border-b hover:bg-gray-50 last:border-0">
                                            <td className="text-center text-sm py-3">Provider Service</td>
                                            <td className="text-center text-sm py-3">
                                                Opcional | Texto | Max:255
                                            </td>
                                        </tr>
                                    </>
                                ) : (
                                    // Sin modo seleccionado: muestra todos
                                    (
                                        criteriaRules as Array<{
                                            title: string
                                            rules: string
                                        }>
                                    ).map((item, index) => (
                                        <tr
                                            key={index}
                                            className="border-b hover:bg-gray-50 last:border-0"
                                        >
                                            <td className="text-center text-sm py-3">
                                                {item.title}
                                            </td>
                                            <td className="text-center text-sm py-3">
                                                {item.rules}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </AppTable>
                    </div>
                    <div className="flex justify-end border-t-2 pt-[32px]  gap-[12px] w-full">
                        <AppButton
                            title="Descartar"
                            state="ghost"
                            onClick={() => navigate(-1)}
                        />
                        <AppButton title="Cargar orden" onClick={sendData} />
                    </div>
                </div>
            </div>
        </>
    )
}
